import { render, staticRenderFns } from "./SwappTasksHistory.vue?vue&type=template&id=66d1d796&scoped=true&"
import script from "./SwappTasksHistory.vue?vue&type=script&lang=js&"
export * from "./SwappTasksHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d1d796",
  null
  
)

export default component.exports